<template>
    <v-list-item :to="{ name: 'N_Knobs' }" :disabled="disabled">
        <v-list-item-icon>
            <v-icon>mdi-gauge</v-icon>
        </v-list-item-icon>
        
        <v-list-item-content>
            <v-list-item-title><v-icon small>mdi-timer-sand</v-icon> Knob</v-list-item-title>
        </v-list-item-content>
    </v-list-item>
</template>

<script>
export default {
    name: 'mNavItemKnob',
    props: {
        disabled: Boolean,
    }
}
</script>